"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.str2Date = str2Date;
exports.formatTime = formatTime;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

// date.js
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };

  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      var str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }

  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

function str2Date(dateStr, separator) {
  if (!separator) {
    separator = '-';
  }

  var dateArr = dateStr.split(separator);
  var year = parseInt(dateArr[0]);
  var month; // 处理月份为04这样的情况

  if (dateArr[1].indexOf('0') == 0) {
    month = parseInt(dateArr[1].substring(1));
  } else {
    month = parseInt(dateArr[1]);
  }

  var day = parseInt(dateArr[2]);
  var date = new Date(year, month - 1, day);
  return date;
}

function formatTime(duration) {
  if (!duration) return "00小时00分00秒";
  var day = parseInt(duration / (60 * 60 * 24));
  var h = parseInt(duration % (60 * 60 * 24) / (60 * 60));
  var m = parseInt((duration - h * 60 * 60 - day * (60 * 60 * 24)) / 60);
  var s = parseInt(duration % 60);
  h = h.toString().length < 2 ? "0" + h.toString() : h.toString();
  m = m.toString().length < 2 ? "0" + m.toString() : m.toString();
  s = s.toString().length < 2 ? "0" + s.toString() : s.toString();
  if (parseInt(day) > 0) return day.toString() + '天' + h + '小时' + m + '分'; // return h+'小时'+m+'分';

  return h + '小时' + m.toString() + '分' + s.toString() + '秒';
}